module.exports = __webpack_public_path__ + "fonts/29e1f75.ttf";